import { render, staticRenderFns } from "./o-toast.vue?vue&type=template&id=2d8be996&scoped=true&"
import script from "./o-toast.js?vue&type=script&lang=js&"
export * from "./o-toast.js?vue&type=script&lang=js&"
import style0 from "./o-toast.scss?vue&type=style&index=0&id=2d8be996&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8be996",
  null
  
)

export default component.exports